<template>
  <div>
    <el-dialog
      v-if="openOff"
      v-dialogStyle
      class="abow_dialog"
      title="合同参数信息"
      destroy-on-close
      :visible.sync="openOff"
      center
      :append-to-body="true"
      :lock-scroll="false"
      width="70%"
      @close="close()">
      <iframe id="iframe" :src="iframeUrl" frameborder="0" width="100%" height="500px"></iframe>
    </el-dialog>
    <div>
      <a style="font-size: 25px">项目名称：{{ projname }} </a>
      <a style="color: red"> 工艺特品未下发总数：{{ counts }} (个)</a>
    </div>
    <div style="margin-bottom: 20px; margin-top: 20px; margin-left: 10px; float: left;">
      <el-button type="primary" size="mini" @click="SpecialProductNotice()">特品通知单</el-button>
      <el-button type="info" size="mini" @click="projectInfo()">项目信息</el-button>
      <el-button type="success" size="mini" @click="affirm()">确认</el-button>
    </div>
    <!-- <div class="search-per" style="float: right;">
      <el-form ref="ruleForm" :model="ruleForm" class="demo-ruleForm" @submit.native.prevent>
        <el-input v-model="ruleForm.inputValue" style="width: 200px" type="text" label="搜索" placeholder="请输入搜索内容" @keyup.enter.native="submitForm('ruleForm')"></el-input>
      </el-form>
    </div> -->
    <div>
      <NoPageTable
        :table-data="tableData"
        :table-label="tableLabel"
        :config="config"
        @handleSelectionChange="handleSelectionChange"
        @cellClick="cellClick">
      </NoPageTable>
    </div>
    <div>
      <span>&nbsp;显示第 1 到第 {{ counts }} 条记录，总共 {{ counts }} 条记录</span>
    </div>
  </div>
</template>

<script>
import NoPageTable from '../../../components/pageComponent/NoPageTable'
import './dialogStyle.js'
export default {
  name: 'dept',
  components: {
    NoPageTable
  },
  props: {
    projorderno: {
      type: String, //类型
      default: null //默认值
    },
    innerid: {
      type: String, //类型
      default: null //默认值
    },
    projname: {
      type: String, //类型
      default: null //默认值
    }
  }, //接收参数
  data() {
    return {
      specialproductcode: '',
      iframeUrl: '',
      openOff: false,
      count: '',
      counts: '',
      BASPATH: '',
      param: '',
      multipleSelection: [],
      ruleForm: {
        inputValue: ''
      },
      //搜索时触发true
      searchFlag: false,
      // 搜索条件对象
      searchObj: {},
      config: {
        fixed: false,
        sizes: [15, 25, 35],
        dataTotalCount: 0,
        pageSize: 15,
        currentPage: 1,
        loading: true,
        searchTables: true,
        height: '58vh',
        indexWidth: '85%'
      },
      tableData: [],
      tableLabel: [
        {
          label: '合同号',
          prop: 'orderno',
          click: true,
          search: ''
        },
        {
          label: '产品型号',
          prop: 'moduleseriescode',
          search: ''
        },
        {
          label: '计划开始时间',
          prop: 'starttime',
          search: '',
          type: 'Date'
        },
        {
          label: '计划结束时间',
          prop: 'endtime',
          search: '',
          type: 'Date'
        },
        {
          label: '名称',
          prop: 'productclass',
          search: ''
        },
        {
          label: '责任人',
          prop: 'gy_respname',
          search: ''
        }
      ]
    }
  },
  created() {
    this.getList()
    this.getCount()
  },
  methods: {
    getList() {
      this.config.loading = true
      const data = {
        orderno: this.projorderno,
        innerid: this.innerid
      }
      this.$fetch('/fesback/processDevelopment/queryProcessInformationList.z', data).then(response => {
        if (response !== '') {
          this.tableData = response
          this.counts = this.tableData.length
          for (var i = 0; i < this.tableData.length; i++) {
            this.tableData[i].gy_respname = '徐喜龙'
          }
          this.config.loading = false
        } else {
          this.tableData = []
          this.config.loading = false
        }
      })
    },
    getCount() {
      this.config.loading = true
      const data = {
        orderno: this.projorderno
      }
      this.$fetch('/fesback/processDevelopment/getCount.z', data).then(response => {
        this.count = response.count
        this.BASPATH = response.BASPATH
        this.config.loading = false
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log('是', this.ruleForm.inputValue)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 确定
    affirm: function() {
      const array = this.multipleSelection
      if (array.length === 0 || array === null) {
        this.$message('选取数据列为空！')
      } else {
        this.$post('/fesback/processDevelopment/processProductsIssued.z', array).then(response => {
          if (response === 'true' && array.length === this.tableData.length) {
            this.$message('下发成功！')
            this.$emit('listenTochildEvent', 'true')
          } else if (response === 'true' && array.length !== this.tableData.length) {
            this.$message('下发成功！')
            this.getList()
          } else {
            this.$message('下发失败！')
          }
        })
      }
    },
    handleSelectionChange(row) {
      this.multipleSelection = row
    },
    //点击弹出
    cellClick(row, column, cell, event) {
      //点击合同号弹出
      if (column.label === '合同号' && row.orderno) {
        this.iframeUrl = this.BASPATH + '/contractSpecialNotice/searchContractParam.z?orderNo=' + row.orderno
        this.openOff = true
      }
    },
    //关闭dialog
    close() {
      this.openOff = false
    },
    // 特品通知单
    SpecialProductNotice() {
      if (this.tableData.length === 0 || this.tableData === null) {
        this.$message('暂无特品数据')
      } else {
        const orderno = this.tableData[0].orderno
        this.iframeUrl = this.BASPATH + '/contractSpecialNotice/searchSpecialNotice.z?orderNo=' + orderno.substring(0, 8) + '&specialNo=' + this.tableData[0].specialproductcode
        this.openOff = true
      }
    },
    //项目信息
    projectInfo() {
    }
  }


}

</script>

<style scoped>
.abow_dialog {
    display: flex;
    justify-content: center;
    align-items: Center;
    overflow: hidden
}
</style>
